import { FormField } from '../../../types/form-builder.types';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shondalai/ui-commons';
import {countries} from "@/data/countries.ts";

interface CountryFieldProps {
  field: FormField;
  value: string;
  onChange: (value: string) => void;
}

export function CountryField({ field, value, onChange }: CountryFieldProps) {
  const config = field.config;
  const disabled = (config as any).disabled;

  return (
    <div className="easyforms-country-field">
      <Select
        value={value || ''}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger id={field.id}>
          <SelectValue placeholder={config.placeholder || 'Select country...'} />
        </SelectTrigger>
        <SelectContent>
          {countries.map((country) => (
            <SelectItem key={country.code} value={country.code}>
              {country.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
